import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import {
  TextInput,
  TextInputIcon
} from '@brandwatch/axiom-components';

const SlidePickerFilterInput = ({
  value,
  onBlur,
  onFocus,
  onChange,
  onInputNode
}) => {
  const onChangeLocal = useCallback((e) => onChange(e.target.value), [onChange]);

  return (
    <TextInput
      value={value}
      onBlur={onBlur}
      onFocus={onFocus}
      onChange={onChangeLocal}
      inputRef={onInputNode}
    >
      <TextInputIcon
        name="magnify-glass"
        align="left"
      />
    </TextInput>
  );
};

SlidePickerFilterInput.propTypes = {
  value: PropTypes.string,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onInputNode: PropTypes.func
};

export default SlidePickerFilterInput;
